import React from "react";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import theme from "../../theme";

function SuggestionsTab(props: {
  selectedCategory: string | any;
  setSelectedCategory: (p: any) => void;
}) {
  const { selectedCategory, setSelectedCategory } = props;
  const { t } = useTranslation();

  const suggestedCategories = [
    { label: t("categories.comedy"), value: "Comedy" },
    { label: t("categories.gaming"), value: "Gaming" },
    { label: t("categories.music"), value: "Music" },
    { label: t("categories.education"), value: "Education" },
    { label: t("categories.entertainment"), value: "Entertainment" },
    { label: t("categories.videoAnimation"), value: "Video/Animation" },
    { label: t("categories.spiritualDevotional"), value: "Spiritual/Devotional" },
    { label: t("categories.technology"), value: "Technology" },
    { label: t("categories.love"), value: "Love" },
    { label: t("categories.song"), value: "Song" },
    { label: t("categories.horror"), value: "Horror" },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        gap: 1,
        px: 1,
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <Button
        size="small"
        color="primary"
        variant={selectedCategory === null ? "contained" : "outlined"}
        onClick={() => setSelectedCategory(null)}
        sx={{
          minWidth: 100,
          flexShrink: 0,
          textTransform: "none",
        }}
      >
        {t("categories.all")}
      </Button>
      {suggestedCategories.map((v) => (
        <Button
          key={v.value}
          size="small"
          color="primary"
          variant={selectedCategory === v.value ? "contained" : "outlined"}
          onClick={() => setSelectedCategory(v.value)}
          sx={{
            minWidth: 100,
            flexShrink: 0,
            textTransform: "none",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {v.label}
        </Button>
      ))}
    </Box>
  );
}

export default SuggestionsTab;
